import useConfig from 'src/config/hooks/useConfig'
import { Abi } from 'thirdweb/utils'
import { CarbonBundleStorageAbi } from '../../abis'
import useContract from '../common/useContract/useContract'

const useCarbonBundleStorageContract = () => {
  const config = useConfig()
  const { contract } = useContract(
    config.contractsAddresses.carbonBundleStorageAddress || '',
    CarbonBundleStorageAbi as Abi
  )

  return contract
}

export default useCarbonBundleStorageContract
